import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NewSubscriptionStep2Page } from './new-subscription-step2';

// import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    NewSubscriptionStep2Page,
  ],
  imports: [
    IonicPageModule.forChild(NewSubscriptionStep2Page),
    // BrMaskerModule,
  ],
  exports: [
    NewSubscriptionStep2Page
  ]
})
export class NewSubscriptionStep2PageModule { }



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step2/new-subscription-step2.module.ts